
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogSort',
  props: {
    visible: { type: Boolean as PropType<boolean>, default: false },
    sortType: { type: String as PropType<string>, default: 'recommendation' },
  },
})
